import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { CategoryType } from '~types/categories';
import { apiService } from '~services/ApiService';

export function useGetCategories() {
  return useQuery<CategoryType[], Error>(
    'allCategories', // Query key
    async () => {
      return await apiService.get<CategoryType[]>('categories');
    },
  );
}
